package com.vamvisions.main.core.data.preferences

import com.vamvisions.main.core.domain.preferences.SystemPreferences
import kotlinx.browser.window

/** Reads the preferences the browser reports. Falls back to "unknown" where the browser API is missing. */
class BrowserSystemPreferences : SystemPreferences {

    override val prefersDarkColorScheme: Boolean
        get() = runCatching { window.matchMedia("(prefers-color-scheme: dark)").matches }.getOrDefault(false)

    override val browserLanguage: String?
        get() = runCatching { window.navigator.language }.getOrNull()
}
